import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bfdb2e3")

_pushScopeId("data-v-1bfdb2e3")
const _hoisted_1 = { class: "col-span-2" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.66667 4.16797H3.33333C2.8731 4.16797 2.5 4.54106 2.5 5.0013C2.5 5.46154 2.8731 5.83464 3.33333 5.83464H3.38704L4.06479 16.0009C4.15234 17.3142 5.2431 18.3346 6.55926 18.3346H13.4407C14.7569 18.3346 15.8477 17.3142 15.9352 16.0009L16.613 5.83464H16.6667C17.1269 5.83464 17.5 5.46154 17.5 5.0013C17.5 4.54106 17.1269 4.16797 16.6667 4.16797H13.3333C13.3333 2.78726 12.214 1.66797 10.8333 1.66797H9.16667C7.78595 1.66797 6.66667 2.78726 6.66667 4.16797ZM8.33333 4.16797C8.33333 3.70773 8.70643 3.33464 9.16667 3.33464H10.8333C11.2936 3.33464 11.6667 3.70773 11.6667 4.16797H8.33333ZM8.33333 8.33464C8.79357 8.33464 9.16667 8.70773 9.16667 9.16797V12.5013C9.16667 12.9615 8.79357 13.3346 8.33333 13.3346C7.8731 13.3346 7.5 12.9615 7.5 12.5013V9.16797C7.5 8.70773 7.8731 8.33464 8.33333 8.33464ZM12.5 9.16797C12.5 8.70773 12.1269 8.33464 11.6667 8.33464C11.2064 8.33464 10.8333 8.70773 10.8333 9.16797V12.5013C10.8333 12.9615 11.2064 13.3346 11.6667 13.3346C12.1269 13.3346 12.5 12.9615 12.5 12.5013V9.16797Z",
    fill: "#B82025"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "receiver-rows-container",
      style: `max-height: ${_ctx.maxHeight}; ${_ctx.localReceivers.length > _ctx.maxItemOverflow ? 'overflow-y: scroll;' : ''}`
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localReceivers, (receiver, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "grid grid-cols-12 gap-x-3 items-start"
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_DataWrapper, {
              label: index === 0 ? _ctx.$t('tagihan.modal.sendTo') : '',
              class: "mb-2",
              optional: _ctx.optional && !index
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  isExpand: receiver.viaExpanded,
                  "onUpdate:isExpand": ($event: any) => (receiver.viaExpanded = $event),
                  options: _ctx.viaOptions,
                  onSelect: (option) => _ctx.onSelectVia(index, option),
                  placeholder: "Email",
                  selectedItem: receiver.via,
                  isDisabled: false,
                  class: `${index === 0 && 'mt-2'}`
                }, null, 8, ["isExpand", "onUpdate:isExpand", "options", "onSelect", "selectedItem", "class"])
              ]),
              _: 2
            }, 1032, ["label", "optional"])
          ]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              class: "w-full mb-2 input-with-error-space",
              label: "Email/Phone",
              fontStyleLabel: index === 0 ? 'invisible' : 'hidden'
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: receiver.value,
                  "onUpdate:modelValue": [($event: any) => (receiver.value = $event), (val) => _ctx.validateReceiver(index, val)],
                  placeholder: _ctx.getPlaceholder(receiver.via),
                  error: receiver.error,
                  errorCaption: receiver.errorMessage,
                  marginVertical: `${index === 0 && 'mt-2'}`,
                  onBlur: (val) => _ctx.validateReceiver(index, val)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "error", "errorCaption", "marginVertical", "onBlur"])
              ]),
              _: 2
            }, 1032, ["fontStyleLabel"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: index === 0 ? _ctx.$t('tagihan.create.formatBill')  : '',
              class: "mb-2"
            }, {
              default: _withId(() => [
                _createVNode("div", {
                  class: ["w-full flex items-center", `${index === 0 && 'mt-2'}`]
                }, [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: receiver.formatExpanded,
                    "onUpdate:isExpand": ($event: any) => (receiver.formatExpanded = $event),
                    options: _ctx.formatOptions,
                    onSelect: (option) => _ctx.onSelectFormat(index, option),
                    placeholder: _ctx.$t('tagihan.create.selectFormat'),
                    selectedItem: receiver.format,
                    isDisabled: false,
                    error: receiver.errorFormat,
                    errorCaption: receiver.errorFormatMessage,
                    onClose: (openSelect) => _ctx.validateFormat(index, openSelect),
                    customClassHeight: "h-full"
                  }, null, 8, ["isExpand", "onUpdate:isExpand", "options", "onSelect", "placeholder", "selectedItem", "error", "errorCaption", "onClose"]),
                  (_ctx.localReceivers.length > 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.removeReceiver(index)),
                        class: "ml-2"
                      }, [
                        _hoisted_4
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1032, ["label"])
          ])
        ]))
      }), 128))
    ], 4),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
})